export enum ShareTabs {
  GROUP = "group",
  ROLE = "role",
  INDIVIDUAL = "individual"
}
